export default({
  init: () => {
    window.nvtag_callbacks = window.nvtag_callbacks || {}
    window.nvtag_callbacks.postRender = window.nvtag_callbacks.postRender || []
    window.nvtag_callbacks.postRender.push(() => {
      const mobileFields = document.querySelectorAll('.at-text.MobilePhone')
      mobileFields.forEach(wrapper => {
        const input = wrapper.querySelector('input')
        const label = wrapper.querySelector('kbd')

        if (label) {
          input.setAttribute('placeholder', label.textContent.replace(' (Optional)', ''))
        }
      })
    })
  }
})
